import HeroSection from "../components/HeroSection";
import AboutComponent from "../components/AboutComponent";
import MissionComponent from "../components/MissionComponent";
import PillarsComponent from "../components/PillarsComponent";
import ProjectComponent from "../components/ProjectComponent";
import ProgramsComponent from "../components/ProgramsComponent";
import PartnershipComponent from "../components/PartnershipComponent";
import ClosingComponent from "../components/ClosingComponent";
import ProjectDesignCatalog from "../components/ProjectDesignCatalog";
import CrowdFundingModel from "../components/CrowdFundingModel";
import Faq from "../components/Faq";
import ScrollToTop from "../components/ScrollToTop";
import BoardOfTrustees from "../components/BoardOfTrustees";
import WhoAreWe from "../components/WhoAreWe";
import Support from "../components/Support";
import ImpactDashboards from "../components/ImpactDashboards";

export default function Home() {
  return (
    <div className="overflow-hidden">
      <div id="home">
        <HeroSection />
      </div>

      <WhoAreWe />

      <section id="about">
        <AboutComponent />
      </section>

      <section id="mission">
        <MissionComponent />
      </section>


   <section id="core-pillar">
        <PillarsComponent />
      </section>
   

      <section id="projects">
        <ProjectComponent />
      </section>

      <ProjectDesignCatalog />

      <CrowdFundingModel />

      

      <section id="programs">
        <ProgramsComponent />
      </section>

      <ImpactDashboards />

      <Support />

      <section id="partnerships">
        <PartnershipComponent />
      </section>

      <BoardOfTrustees />

      <Faq /> 

      <section id="closing">
        <ClosingComponent />
      </section>

      <ScrollToTop /> 
    </div>
  );
}
